<template>
  <section id="how-it-works" class="eu">
    <div class="intro">
      <translate tag="p">
        We're thrilled to share our shortlist of the best camping, glamping and
        caravan sites based on nearly 200,000 customer reviews last year.
      </translate>
      <translate tag="p">
        To feature in the list, sites must have achieved an average rating of 8
        or above across at least 20 reviews in 2024. We keep the criteria simple
        and rely solely on verified customer feedback to ensure the list is
        unbiased and reflects real user experiences.
      </translate>
      <translate tag="p">
        We want to say a huge congratulations to the winning sites. Their
        outstanding average rating is the result of months of glowing reviews on
        Pitchup.com, showing that they provided a truly exceptional guest
        experience.
      </translate>
    </div>
    <img
      v-if="$isDesktop"
      :src="badgeImgUrl"
      alt=""
      width="320"
      height="373"
      class="intro-badge"
      loading="lazy"
    />
  </section>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

const glob = import.meta.glob('@/assets/images/review-awards-badge*.png', {
  query: '?url',
  eager: true,
})

@Component
class ReviewAwardsIntro extends Vue {
  get badgeImgUrl() {
    if (
      this.$i18n.locale === 'fr' ||
      this.$i18n.locale === 'it' ||
      this.$i18n.locale === 'es'
    ) {
      return glob[`/assets/images/review-awards-badge-${this.$i18n.locale}.png`]
        ?.default
    } else {
      return glob[`/assets/images/review-awards-badge.png`]?.default
    }
  }
}
export default toNative(ReviewAwardsIntro)
</script>
